module.exports = __webpack_public_path__ + "img/wm-system-demo5.d8ab9aae.png";